@if (!data.html) {
  <div mat-dialog-content [class]="getTheme()" style="white-space: pre-line;">
    {{ data.message }}
  </div>
}
@if (data.html) {
  <div [innerHTML]="data.message"></div>
}
<div mat-dialog-actions [class]="getTheme()">
  <div fxFlex></div>
  @if (data.canOk) {
    <button mat-raised-button color="primary" (click)="onOkClick()">
    {{ data.messageOk }}</button>
  }
  @if (data.canCancel) {
    <button mat-raised-button color="secondary" (click)="onNoClick()">
      {{ data.messageCancel }}
    </button>
  }
</div>